import { Formatter } from "utils/formatters";
import { LayoutUserSubscriptionProps } from "./type";
import { useEffect, useState } from "react";
import { Plan, fetchPlans } from "services/fetch-plans";
import { useNavigate } from "react-router-dom";

export function LayoutUserSubscription({
  profile,
  recurrent,
  infoPayment,
}: Readonly<LayoutUserSubscriptionProps>) {
  const [plans, setPlans] = useState<Plan[]>([]);
  const navigate = useNavigate();
  const points = plans.find(
    (plan) =>
      plan.name.toLowerCase() ===
      profile.subscription?.plan_name.toLocaleLowerCase()
  )?.points;

  useEffect(() => {
    fetchPlans().then((response) => {
      setPlans(response.data);
    });
  }, []);

  if (plans.length === 0) {
    return null;
  }

  const handleClickUpdatePayment = () => {
    navigate(`/account/update-payment?id=${recurrent?.recurrent_payment.recurrent_payment_id}`);
  }

  return (
    <section className="w-full h-full flex flex-col justify-start items-start">
      <div className="flex flex-col w-full px-1 md:px-4">
        <h1 className="text-2xl font-bold mb-4">
          {profile.subscription?.plan_name}
        </h1>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="w-full space-y-3 mt-8">
          <p className="text-xl font-semibold">
            Valor Mensal:{" "}
            <span className="font-light italic ml-2">
              {profile.subscription?.monthly_value.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </span>
          </p>

          {recurrent?.recurrent_payment?.next_recurrency ? (
            <p className="text-xl font-semibold">
              Próxima Fatura:{" "}
              <span className="font-light italic ml-2">
                {Formatter.prettyDateBRFormated(
                  recurrent?.recurrent_payment?.next_recurrency ?? ""
                )}
              </span>
            </p>
          ) : null}

          {infoPayment?.card_number &&
          infoPayment?.brand ? (
            <p className="text-xl font-semibold">
              Cartão:{" "}
              <span className="font-light italic ml-2">
                {infoPayment?.card_number} (
                {infoPayment?.brand})
              </span>
            </p>
          ) : null}

          <p className="text-xl font-semibold">
            ViroCash por ano:{" "}
            <span className="font-light italic ml-2">
              {
                Intl.NumberFormat("pt-BR", {
                }).format(points ?? 0)
              }{" "}
              ViroCash / ano
            </span>
          </p>

          <p className="text-xl font-semibold">
            Data de Adesão:{" "}
            <span className="font-light italic ml-2">
              {Formatter.prettyDateBRFormated(
                profile.subscription?.starts_at ?? ""
              )}
            </span>
          </p>

          {!recurrent?.recurrent_payment?.next_recurrency ? (
            <p className="text-xl font-semibold">
              Método de Pagamento:{" "}
              <span className="font-light italic ml-2">Desconto em Folha</span>
            </p>
          ) : null}

          {!recurrent?.recurrent_payment?.next_recurrency ? (
            <p className="text-base text-gray-600 dark:text-gray-400 mt-3">
              Esta é a forma de pagamento escolhida por você. Caso deseje
              alterar, entre em contato com o RH da sua empresa.
            </p>
          ) : null}
        </div>
        <button 
          className="
            bg-[#4F46E5] hover:bg-[#4F46E5]/80 
            hover:dark:bg-[#4F46E5]/60 transition-colors 
            duration-500 ease-in-out text-white w-full 
            md:w-44 font-semibold py-2 px-4 rounded-full mt-8
          "
          onClick={handleClickUpdatePayment}
        >
          Alterar Cartão
        </button>
      </div>
    </section>
  );
}
